module.exports = __webpack_public_path__ + "img/SEELift.c5131827.svg";